import { render, staticRenderFns } from "./PurchaseItem.vue?vue&type=template&id=fb94b3e2&"
import script from "./PurchaseItem.vue?vue&type=script&lang=js&"
export * from "./PurchaseItem.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports